import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { NotificationApi } from "@/Modules/Models/Api/ActivityCenter";
import type { ACNotification } from "@/Modules/Models/Domain/ActivityCenter";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { setIconAndRole } from "@/Modules/ActivityCenter/Helpers";

import { camel } from "@/Utils/Camelize";

const NotificationTransformer: TransformerExtended<ACNotification, NotificationApi> = {
  ...DefaultTransformerGenerator<ACNotification, NotificationApi>(),

  toDomain(input: NotificationApi) {
    return {
      ...camel(input),
      ...setIconAndRole(input),
    };
  },
};

export type NotificationTransformerType = TransformerExtended<ACNotification, NotificationApi>;

export default NotificationTransformer;
